import React, { Fragment } from 'react';
import styles from './Radio.module.scss'

import Typography from 'Atoms/Typography'
import Card from 'Atoms/Card'
import Divider from 'Atoms/Divider'

const Radio = (
  {
    values,
    cardRadioItems,
    inlineRadioLabel,
    radioSize = 0.75,
    id,
    ...props
  }
) => {
  const radioOptions = values.map((value, index) =>
    <Fragment key={index}>
      {cardRadioItems ?
        <>
          <div className={styles.radioInputItem}>
            <input
              type="radio"
              id={`${id}-${index}`}
              name={`${id}`}
              style={{height: radioSize + 'rem', width: radioSize + 'rem'}}
              className={styles.radioItemPadding}
              value={value?.value ?? ""}
              {...(value.checked ? { checked: !!value.checked } : {})}
              disabled={value.disabled}
              {...props} />
            <Typography as={'label'} htmlFor={`${id}-${index}`} size={1} className={styles.radioLabelText}>
              {value.label}
            </Typography>
          </div>
          {index + 1 != values.length ? <Divider className={styles.divider} /> : false}
        </>
        :
        <>
          <input
            type="radio"
            id={`${id}-${index}`}
            name={`${id}`}
            style={{height: radioSize + 'rem', width: radioSize + 'rem'}}
            value={value?.value ?? ""}
            {...(value.checked ? { checked: !!value.checked } : {})}
            disabled={value.disabled}
            {...props} />
          <Typography as={'label'} htmlFor={`${id}-${index}`} size={1}>
            {value.label}
          </Typography>
          <br />
        </>
      }
    </Fragment>
  );

  return (
    <Fragment>
      {cardRadioItems ? <Card fill noPadding>{radioOptions}</Card> : radioOptions}
    </Fragment>
  );
}


export default Radio;